import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SessionExpiredModal() {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();

  const handleRelogin = () => {
    setIsOpen(false);
    navigate("/login"); // 👈 redirects to your login page
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-500 bg-opacity-60">
          <div className="bg-white rounded-lg shadow-lg w-[630px] p-[80px] text-center">
            {/* Title */}
            <h2 className="text-[22px] font-semibold text-brandBlue">
              Your session has Expired
            </h2>

            {/* Subtext */}
            <p className="text-[15px] text-gray-600 mt-5">Please login again</p>

            {/* Button */}
            {/* Re-Login Button */}
            <button
              onClick={handleRelogin}
              className="btn-primary bg-brandBlue w-full text-white font-medium rounded-md py-[17px] px-4 text-base transition mt-8 hover:bg-primary-700"
            >
              Re-Login
            </button>

            {/* Info */}
            <p className="text-[15px] text-gray-500 mt-8">
              Log Out after 30min of inactivity
            </p>
          </div>
        </div>
      )}
    </>
  );
}
